import { FC, useState } from "react";
import { useSelector } from "react-redux";

import { formatMediasDateTime } from "../../../../utils/formatDate";
import {
  findAiPhotoResult,
  shouldShowAiResults,
} from "../../../../utils/aiResults";
import {
  getPhotoSceneLabel,
  getPhotoOriginalUrl,
} from "../../../../utils/reportPhoto";
import ArrowIcon from "../../../../assets/icons/chevron.svg";
import AiResultCell from "../../../custom/aiResultCell/aiResultCell";
import AiPhotoThumb from "../../../custom/aiPhotoThumb/aiPhotoThumb";

import { IReportMediaOptions } from "../../../../types/reportsInterfaces";
import { IUserOptions } from "../../../../types/interfaces";

interface ICustomerPhotoOptions {
  setSelectedPhoto: (src: string, original?: boolean) => void;
  medias: IReportMediaOptions[];
  title: string;
}

const CustomerPhotoTableSection: FC<ICustomerPhotoOptions> = ({
  setSelectedPhoto,
  medias,
  title,
}) => {
  const [isVisibleData, setIsVisibleData] = useState<boolean>(true);
  const { aiReview, aiReviewSummary } = useSelector(
    (state: any) => state.userSingleReport.userSingleReport
  );
  const { data } = useSelector((state: IUserOptions) => state.user.user);
  const showAiResults = shouldShowAiResults(
    data?.isCustomer,
    data?.settings?.aiReview,
    data?.claims
  );

  return (
		<div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
      <span className="section__title">{title}</span>
      <button
				className='sectionData_button'
				onClick={() => setIsVisibleData(!isVisibleData)}
			>
				<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
			</button>
      <div className="customer__photo_table">
        {medias.map((elem: IReportMediaOptions, index: number) => {
          const photoAi = showAiResults
            ? findAiPhotoResult(aiReview, elem)
            : null;
          const sceneLabel = getPhotoSceneLabel(
            elem,
            aiReview,
            aiReviewSummary
          );

          return (
            <div className="customer__photo_block" key={index}>
              <div className="photo__block_row">
                <AiPhotoThumb
                  src={elem?.url?.link}
                  mediaId={elem.media.id}
                  id={String(elem.media.id)}
                  onClick={() => setSelectedPhoto(elem?.url?.link)}
                  showOverlay={showAiResults}
                  aiReview={aiReview}
                />
              </div>
              {sceneLabel && (
                <div className="photo__block_row">
                  <span className="photo__scene_text">Сцена: {sceneLabel}</span>
                </div>
              )}
              <div className="photo__block_row">
                <span className="photo__card_name">{elem.media.name}</span>
              </div>
              <div className="photo__block_row">
                <span>{elem.date && formatMediasDateTime(elem.date)}</span>
              </div>
              {showAiResults && photoAi && (
                <div className="photo__block_row photo__block_row-ai">
                  <AiResultCell item={photoAi} />
                </div>
              )}
              <div className="photo__block_row photo__block_row-actions">
                <button
                  type="button"
                  className="photo__original_btn"
                  onClick={() =>
                    setSelectedPhoto(
                      getPhotoOriginalUrl(elem) || elem?.url?.link,
                      true
                    )
                  }
                >
                  Показать оригинал
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CustomerPhotoTableSection;
